export default __webpack_public_path__ + "static/media/tempat.eff9c196.svg";